<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-main">
        <!-- Brand -->
        <div class="footer-brand">
          <router-link to="/" class="footer-logo">
            <img :src="brandLogoSrc" alt="点石引擎 Dianshi Engine" class="footer-logo-img" width="260" height="48" />
          </router-link>
          <p class="brand-desc">一站式企业AI应用平台，让每一个想法都找到它的执行引擎。</p>

          <!-- Social links -->
          <div class="social-links">
            <a href="#" class="social-btn" title="微信公众号">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.317 4.492c-1.53-.69-3.17-1.2-4.885-1.49a.075.075 0 00-.079.036c-.21.369-.444.85-.608 1.23a18.566 18.566 0 00-5.487 0 12.36 12.36 0 00-.617-1.23A.077.077 0 008.562 3c-1.714.29-3.354.8-4.885 1.491a.07.07 0 00-.032.027C.533 9.093-.32 13.555.099 17.961a.08.08 0 00.031.055 20.03 20.03 0 005.993 2.98.078.078 0 00.084-.026 13.83 13.83 0 001.226-1.963.074.074 0 00-.041-.104 13.175 13.175 0 01-1.872-.878.075.075 0 01-.008-.125c.126-.093.252-.19.372-.287a.075.075 0 01.078-.01c3.927 1.764 8.18 1.764 12.061 0a.075.075 0 01.079.009c.12.098.245.195.372.288a.075.075 0 01-.006.125c-.598.344-1.22.635-1.873.877a.075.075 0 00-.041.105c.36.687.772 1.341 1.225 1.962a.077.077 0 00.084.028 19.963 19.963 0 006.002-2.981.076.076 0 00.032-.054c.5-5.094-.838-9.52-3.549-13.442a.06.06 0 00-.031-.028z"/></svg>
            </a>
            <a href="#" class="social-btn" title="微博">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"/></svg>
            </a>
            <a href="#" class="social-btn" title="抖音">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 12a4 4 0 100 8 4 4 0 000-8zM15 4a4 4 0 004 4V4h-4zM9 8v4"/></svg>
            </a>
            <a href="#" class="social-btn" title="B站">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="15" rx="3" ry="3"/><polyline points="17 2 12 7 7 2"/><line x1="8" y1="12" x2="8" y2="16"/><line x1="16" y1="12" x2="16" y2="16"/></svg>
            </a>
          </div>
        </div>

        <!-- Nav columns -->
        <div class="footer-links" v-for="col in footerLinks" :key="col.title">
          <h4 class="footer-col-title">{{ col.title }}</h4>
          <ul>
            <li v-for="link in col.links" :key="link">
              <a href="#" class="footer-link">{{ link }}</a>
            </li>
          </ul>
        </div>

        <!-- Contact -->
        <div class="footer-contact">
          <h4 class="footer-col-title">联系我们</h4>
          <div class="contact-items">
            <div class="contact-item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              lxy@jbr.net.cn
            </div>
            <div class="contact-item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 01.03 2.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.08 6.08l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
              400-9027-208
            </div>
            <div class="contact-item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
              湖北省武汉市东湖新技术开发区光谷大道现代光谷世贸中心J栋
            </div>
          </div>

          <!-- Newsletter -->
          <div class="newsletter">
            <p class="newsletter-label">订阅更新</p>
            <div class="newsletter-input">
              <input type="email" placeholder="输入您的邮箱" />
              <button>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="copyright">
          © 2024 点石引擎. 保留所有权利. 鄂ICP备13003992号-9
        </div>
        <div class="footer-bottom-links">
          <a href="#" class="footer-bottom-link">隐私政策</a>
          <a href="#" class="footer-bottom-link">服务条款</a>
          <a href="#" class="footer-bottom-link">Cookie政策</a>
          <a href="#" class="footer-bottom-link">帮助中心</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { getBrandLogoSrc } from '@/constants/brand'

export default {
  name: 'TheFooter',
  props: {
    isDark: { type: Boolean, default: false },
  },
  computed: {
    brandLogoSrc() {
      return getBrandLogoSrc(this.isDark)
    },
  },
  data() {
    return {
      footerLinks: [
        {
          title: '产品',
          links: ['工作流商店', '智能体中心', '办公助手', 'AI视频生成', 'AI文案创作', 'AI数据分析']
        },
        {
          title: '解决方案',
          links: ['企业AI转型', '内容创作团队', '电商卖家', '知识博主', '职场人士', '创业者']
        },
        {
          title: '资源',
          links: ['使用文档', '视频教程', '创业项目', 'API文档', '合作伙伴', '博客']
        },
      ]
    }
  }
}
</script>

<style scoped>
.site-footer {
  background: var(--bg-alt);
  border-top: 1px solid var(--border);
  padding: 72px 0 0;
}

.footer-main {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 2fr;
  gap: 40px;
  padding-bottom: 56px;
  border-bottom: 1px solid var(--border);
}

/* Brand */
.footer-logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  margin-bottom: 16px;
}
.footer-logo-img {
  height: 48px;
  width: auto;
  max-width: min(300px, 90vw);
  display: block;
  object-fit: contain;
}
.brand-desc {
  font-size: 0.85rem;
  color: var(--text-muted);
  line-height: 1.7;
  margin-bottom: 20px;
  max-width: 240px;
}

.social-links { display: flex; gap: 8px; }
.social-btn {
  width: 36px; height: 36px;
  border-radius: 10px;
  border: 1.5px solid var(--border);
  background: var(--bg-card);
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.2s;
}
.social-btn:hover { border-color: var(--primary); color: var(--primary); background: var(--primary-light); }

/* Links */
.footer-col-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 16px;
}
ul { list-style: none; display: flex; flex-direction: column; gap: 10px; }
.footer-link {
  font-size: 0.84rem;
  color: var(--text-muted);
  text-decoration: none;
  transition: color 0.2s;
}
.footer-link:hover { color: var(--primary); }

/* Contact */
.contact-items { display: flex; flex-direction: column; gap: 12px; margin-bottom: 24px; }
.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 0.84rem;
  color: var(--text-muted);
  line-height: 1.5;
}
.contact-item svg { flex-shrink: 0; color: var(--primary); margin-top: 2px; }

/* Newsletter */
.newsletter-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin-bottom: 10px;
}
.newsletter-input {
  display: flex;
  gap: 0;
  border: 1.5px solid var(--border);
  border-radius: 10px;
  overflow: hidden;
  background: var(--bg-card);
}
.newsletter-input input {
  flex: 1;
  padding: 10px 14px;
  border: none;
  background: transparent;
  color: var(--text);
  font-size: 0.84rem;
  outline: none;
}
.newsletter-input input::placeholder { color: var(--text-muted); }
.newsletter-input button {
  padding: 0 16px;
  background: var(--gradient-brand);
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: opacity 0.2s;
}
.newsletter-input button:hover { opacity: 0.85; }

/* Bottom */
.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  gap: 16px;
  flex-wrap: wrap;
}
.copyright {
  font-size: 0.8rem;
  color: var(--text-muted);
}
.footer-bottom-links { display: flex; gap: 20px; flex-wrap: wrap; }
.footer-bottom-link {
  font-size: 0.8rem;
  color: var(--text-muted);
  text-decoration: none;
  transition: color 0.2s;
}
.footer-bottom-link:hover { color: var(--primary); }

@media (max-width: 1200px) {
  .footer-main { grid-template-columns: 1fr 1fr 1fr; }
  .footer-brand { grid-column: span 3; }
  .footer-contact { grid-column: span 3; }
}
@media (max-width: 768px) {
  .footer-main { grid-template-columns: 1fr 1fr; }
  .footer-brand { grid-column: span 2; }
  .footer-contact { grid-column: span 2; }
}
@media (max-width: 480px) {
  .footer-main { grid-template-columns: 1fr; }
  .footer-brand, .footer-contact { grid-column: span 1; }
  .footer-bottom { flex-direction: column; align-items: flex-start; }
}
</style>
